import { Component, OnInit } from '@angular/core';
import { formatDateSvSE, isNotEmpty } from '@app/fremework/functions';

import { MatDivider } from '@angular/material/divider';
import {
  MatList,
  MatListItem,
  MatListItemAvatar,
  MatListItemLine,
  MatListItemTitle,
} from '@angular/material/list';
import { SelectedRaceService } from '@app/services/selected-race.service';
import { Race } from '@app/rest-client/faxe/models/race';
import { MatButton } from '@angular/material/button';
import { SyncService } from '@app/rest-client/faxe/services/sync.service';
import { SnackService } from '@app/components/shared/snack/snack.service';

@Component({
  selector: 'faxe-import-race-data',
  imports: [
    MatDivider,
    MatList,
    MatListItem,
    MatListItemAvatar,
    MatListItemLine,
    MatListItemTitle,
    MatButton,
  ],
  templateUrl: './import-race-data.component.html',
  styleUrl: './import-race-data.component.scss',
})
export class ImportRaceDataComponent implements OnInit {
  selectedRace: Race;

  constructor(
    private readonly selectedRaceService: SelectedRaceService,
    private readonly syncService: SyncService,
    private readonly snackService: SnackService
  ) {}

  ngOnInit(): void {
    this.selectedRaceService.selectedRace$.subscribe(
      (race) => (this.selectedRace = race)
    );
  }

  protected readonly formatDateSvSE = formatDateSvSE;

  onImport(selectedRace: Race) {
    this.syncService
      .synchronizeRiders({ raceGuid: selectedRace.raceGuid })
      .subscribe((race) =>
        this.snackService.showSnackBar('Import från Equipe slutförd.')
      );
  }
}
